import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/plugins", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
